
<template>
  <div class="top6f">
    <div class="top6">
      <div class="boxtitle">
        <div class="btitle">
          <span>读者推荐展示区</span>
        </div>
        <div class="bbtn">
          <i class="el-icon-arrow-left"></i>
          <i class="el-icon-arrow-right"
             style="color:#0B8586"></i>
        </div>
      </div>
      <div class="t6fbox">
        <div class="t6left">
          <div class="t6ll">
            <img src="https://cgp-resource.oss-cn-beijing.aliyuncs.com/Images/Reading/reader.jpg"
                 alt="" />
            <div class="t6ll2">
              <span>【爆裂：未来社会的9大生存原则】</span>
            </div>
            <div class="t6ll3">
              <span>推荐人xxx：从初级到高级，只需要一本书</span>
            </div>
          </div>
          <div class="t6lr">
            作者: [美] 伊藤穰一 / [美] 杰夫·豪<br>
            出版社: 中信出版社<br>
            副标题: 未来社会的9大生存原则<br>
            原作名: Whiplash: How to Survive Our Faster Future<br>
            译者: 张培 / 吴建英 / 周卓斌<br>
            出版年: 2017-10-1<br>
            页数: 344<br>
            定价: 65.00元<br>
            装帧: 精装<br>
            ISBN: 9787508680231
          </div>
        </div>
        <div class="t6right">
          <div class="t6rbox">
            <div class="t6item"
                 v-for="(item,index) in 4"
                 :style="index==0?'border-top:0;':''"
                 :key="index">
              <img class="t6ipic"
                   src="https://cgp-resource.oss-cn-beijing.aliyuncs.com/Images/Reading/reader.jpg"
                   alt="" />
              <div class="t6iright">
                <span class="t6iname">歇斯底里</span>
                <span class="t6itime">2022-6-6 12:23</span>
                <span class="t6itext">每个角色，都是真实的立体的人，而不 是工具人。</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="t6bot">
        <div class="t6bbtn t6bbtn1">
          <img src="../../../assets/img/reading/t61.png"
               alt="">
          <span>我要评论</span>
        </div>
        <div class="t6bbtn t6bbtn2">
          <img src="../../../assets/img/reading/t62.png"
               alt="">
          <span>我要购买</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  }
}
</script>
<style lang="scss" scoped>
.top6f {
    width: 100%;
    height: 566px;
    background: #f5f7fa;
    overflow: hidden;
    .top6 {
        width: 1200px;
        margin: 0 auto;
        .boxtitle {
            width: 100%;
            border-bottom: 1px solid #ddd;
            margin: 40px 0 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .btitle {
                display: inline-block;
                font-size: 26px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                line-height: 26px;
                padding: 15px 0;
                border-bottom: 1px solid #000000;
            }
            .bbtn {
                font-size: 20px;
                i {
                    margin-left: 15px;
                    cursor: pointer;
                }
            }
        }
        .t6fbox {
            width: 1200px;
            display: flex;
            justify-content: space-between;
            .t6left {
                width: 797px;
                height: 324px;
                background: #ffffff;
                box-shadow: 5px 14px 35px 0px rgba(0, 0, 0, 0.06);
                padding: 30px;
                box-sizing: border-box;
                display: flex;
                .t6ll {
                    display: flex;
                    flex-direction: column;
                    width: 330px;
                    margin-right: 50px;
                    img {
                        width: 330px;
                        height: 174px;
                    }
                    .t6ll2 {
                        font-size: 16px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        color: #000000;
                        line-height: 70px;
                    }
                    .t6ll3 {
                        font-size: 14px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        color: #000000;
                        line-height: 20px;
                    }
                }
                .t6lr {
                    flex: 1;
                    font-size: 14px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #000000;
                    line-height: 26px;
                }
            }
            .t6right {
                width: 393px;
                height: 324px;
                background: #ffffff;
                box-shadow: 5px 14px 35px 0px rgba(0, 0, 0, 0.06);
                box-sizing: border-box;
                padding: 10px 2px;
                .t6rbox {
                    height: 100%;
                    overflow-y: auto;
                    .t6item {
                        width: 320px;
                        margin-left: 30px;
                        padding: 20px 0;
                        border-top: 1px solid #eee;
                        display: flex;
                        .t6ipic {
                            width: 68px;
                            height: 68px;
                            border-radius: 50%;
                            margin-right: 15px;
                        }
                        .t6iright {
                            display: flex;
                            flex-direction: column;
                        }
                        .t6iname {
                            font-size: 16px;
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            color: #000000;
                            line-height: 24px;
                        }
                        .t6itime {
                            font-size: 14px;
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            color: #000000;
                            line-height: 28px;
                        }
                        .t6itext {
                            font-size: 14px;
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            color: #000000;
                            line-height: 20px;
                        }
                    }
                }
                .t6rbox::-webkit-scrollbar {
                    width: 5px;
                    background: transparent;
                }

                /* 滚动槽 */
                .t6rbox::-webkit-scrollbar-track {
                    background: #0b86862a;
                    border-radius: 2px;
                }

                /* 滚动条滑块 */
                .t6rbox::-webkit-scrollbar-thumb {
                    background: #0b8586;
                    border-radius: 2px;
                }
            }
        }
        .t6bot {
            display: flex;
            justify-content: center;
            margin-top: 30px;
            .t6bbtn {
                width: 171px;
                height: 40px;
                border-radius: 20px;
                box-sizing: border-box;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                line-height: 16px;
                cursor: pointer;
                img {
                    margin-right: 7px;
                }
            }
            .t6bbtn1 {
                background: #def3f3;
                border: 1px solid #0b8586;
                color: #0b8586;
            }
            .t6bbtn2 {
                background: #fcf6f6;
                border: 1px solid #d7000b;
                color: #d7000b;
                margin-left: 10px;
            }
        }
    }
}
</style>